import JWTInterceptor from "../JWT/JWTInterceptor";
import axios from "axios";
const LoginService = {
  verifyUser: async () => {
    return JWTInterceptor.get(`${process.env.REACT_APP_API_FH_BASE_URL}auth`)
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return error;
      });
  },
  countryDetails: async () => {
    return JWTInterceptor.get(`${process.env.REACT_APP_Admin_APP_BASE_URL}UserAccess/getuserCountryList`)
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return error;
      });
  },
  menuAccessDetails: async () => {
    return JWTInterceptor.get(`${process.env.REACT_APP_Admin_APP_BASE_URL}UserAccess/getModuleAccessnavigation`)
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return error;
      });
  },
  userDetails: async () => {
    // debugger;
    // return JWTInterceptor.get(
    //   `https://beta-wlapi.fh.org/api/v1/users?with[]=AssignedRoles.AssignedAreas&with[]=AssignedRoles.Role&with[]=Locale&whereEmail=jrajvendor@fh.org`
    // )
    //   .then((res) => {
    //     return res;
    //   })
    //   .catch((error) => {
    //     return error;
    //   });
    return new Promise((resolve, reject) => {
      resolve({
        isAxiosError: null,
        data: {
          success: true,
          data: [
            {
              UserId: 1,
              AssignedRoles: [
                {
                  Role: {
                    Name: "SuperAdmin",
                  },
                  AssignedAreas: [
                    {
                      AreaId: 1,
                      AreaName: "Area1",
                    },
                  ],
                },
              ],
            },
          ],
        },
      });
    });
  },
  getRedirectURL: async () => {
    return axios.get(`${process.env.REACT_APP_OKTA_API_BASE_URL}Oktagerneateauthurl`)
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return error;
      });
  },
  getAccessToken: async (authcode:any,code:any) => {
    return axios.get(`${process.env.REACT_APP_OKTA_API_BASE_URL}getoktaaccesstoken?authorizationCode=${authcode}&codeVerifier=${code}`)
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return error;
      });
  },
  refreshToken: async (refreshToken:any) => {
      return JWTInterceptor.get(`${process.env.REACT_APP_OKTA_API_BASE_URL}getoktarefreshtoken?refreshToken=${refreshToken}`)
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return error;
      });
  },
  savePreferredLanguage: async (payload: any) => {
    return JWTInterceptor.post(
      `${process.env.REACT_APP_USERACCESS_API_BASE_URL}Applications/SavePreferredLanguage`,
      payload
    )
      .then((res) => {
        return res;
      })
      .catch((error) => {
        return error;
      });
  },
  // savePreferredLanguage: async (payload: any) => {
  //   return JWTInterceptor.post(
  //     `${process.env.REACT_APP_Admin_APP_BASE_URL}Applications/SavePreferredLanguage`,
  //     payload
  //   )
  //     .then((res) => {
  //       return res;
  //     })
  //     .catch((error) => {
  //       return error;
  //     });
  // },
};
export default LoginService;
